<template>
  <div v-if="values_genre.length>0" :class="class_" :style="advanced?'':'display:block'">
    <div v-if="!is_all_on_top" class="works-filter__block-title">{{ $t("message.Genre") }}</div>

    <div v-if="is_all_on_top" class="works-filter__block-item">
      <div class="works-filter__block-title">{{ $t("message.Genre") }}</div>

      <div v-if="!is_full && (values_genre.length > 5)" v-on:click="show_full" class="pointer works-filter__arrow" style="transform: rotate(180deg);">
        <img src="/res/subdomains/img/light/filter-arrow.svg" alt="">
      </div>
    </div>

    <input ref="search" v-show="is_full" type="" v-model="searchVal" name="" :placeholder="$t('message.QuikSearch')" class="ref-input ref-input-md ref-input-block">
    <div class="list-container">
      <label :class="label_class" v-for="(val, index) in filteredValues_genre" v-show="is_full || (index < 5)">
        <span class="checkbox">
          <input type="checkbox"  v-model="genre[val.value]" @change="change_val_genre(val)">
          <span class="check"></span>
        </span>
        {{val.label}}
      </label>
    </div>

    <div v-if="!is_all_on_top && !is_full && (values_genre.length > 5)">
      <label class="pointer list-container-more" v-on:click="is_full=true">
        <img src="/res7/img/svg/icons/plus-clear.svg" width="14" height="14"/>
        {{ $t("message.GenreAll") }}
      </label>
    </div>
  </div>
</template>


<script>
  import FilterGenreMix from "../../../../../components/list/filter/FilterGenreMix";

  export default {
    name      : 'filter-genre-sub',
    props:{
      is_show: { type: Boolean, default: true },
      label_class: {type: String, default:''},
      is_all_on_top: { type: Boolean, default: false },
    },
    mixins: [FilterGenreMix],
  }
</script>



// WEBPACK FOOTER //
// src/sub/air_light/components/list/filter/FilterGenreSub.vue